import React from "react";
import { useEffect, useState } from "react";
import { Header } from "../../../components/common/Header.js";
import { SideBar } from "../../../features/SideBar/SideBar.js";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
//API
import { getDetail } from "../DetailSlice.js";
import { getSeasonDetail } from "../DetailSlice.js";
import { getEpisode } from "../../../api/apiSetUp.js";
//Child Comp
import { InfoShowcase } from "../../../features/MovieShowcase/InfoShowcase.js";
import { WatchShowcase } from "../../../features/MovieShowcase/WatchShowcase.js";
import { SeasonShowcase } from "../../../features/TvShowcase/SeasonShowcase.js";
import Breadcrumb from "../../../components/common/BreadCrumb.js";
import { ImageShowcase } from "../../../features/MovieShowcase/MediaShowcase.js";
//Utility
import { extractEpisodeData } from "../../../utility/utility.js";
//Style
import "../DetailsPage.css";

export const EpisodeDetailPage = (props) => {
  const { tvId, seasonId, episodeId } = useParams();
  let [imageLoading, setImageLoading] = useState(true);
  let [episodeData, setEpisodeData] = useState(null);
  let [imageError, setImageError] = useState(false);

  //Get Config
  let apiUtility = useSelector((state) => state.apiUtility.apiUtility);
  let { langConfig, tvGenreList } = apiUtility;

  //Handle API Call
  const dispatch = useDispatch();
  let detailDataList = useSelector((state) => state.detail);

  let [tvDetailData, setTvDetailData] = useState(null);
  //Get TV Data
  useEffect(() => {
    if (!detailDataList.detailList["tvList"][tvId]) {
      if (tvDetailData) {
        setTvDetailData(null); //MidAutumn
      }
      dispatch(getDetail({ id: tvId, type: "tv" })).then((res) =>
        setTvDetailData(res.payload)
      );
    } else {
      setTvDetailData(detailDataList.detailList.tvList[tvId]);
    }
  }, [tvId]);

  let [seasonData, setSeasonData] = useState(null);

  //Update Season Data and Episode Data
  useEffect(() => {
    if (detailDataList.detailList["tvList"][tvId]) {
      let targetSeason = detailDataList.detailList.tvList[tvId].seasons.filter(
        (item) => item.season_number == seasonId
      )[0];
      setSeasonData(targetSeason);
    }
    if (seasonData && seasonData.seasonDetail.seasonLoading == false) {
      console.log(seasonData);
      let targetEpisode = seasonData.seasonDetail.seasonInfo.episodes.filter(
        (item) => item.episode_number == episodeId
      )[0];
      setEpisodeData(targetEpisode);
    }
  }, [seasonId, episodeId, seasonData, detailDataList]);

  //Get Season Details Data
  useEffect(() => {
    if (seasonData && seasonData.seasonDetail.seasonLoading == true) {
      dispatch(
        getSeasonDetail({
          tvId: tvId,
          seasonNumber: seasonData.season_number,
        })
      );
    }
  }, [seasonData]);

  //Get Episode Credits, Images and Video
  useEffect(() => {
    if (episodeData && !episodeData.images) {
      async function getEpisodeData() {
        try {
          const response = await getEpisode(tvId, seasonId, episodeId);
          const formatResponse = extractEpisodeData(response);
          setEpisodeData((prev) => {
            return { ...prev, images: formatResponse.images };
          });
          setImageLoading(false);
        } catch (err) {
          setImageLoading(false);
          setImageError(true);
        }
      }
      getEpisodeData();
    }
  }, [episodeId, episodeData]);

  //Custom InfoShowcase Props
  function customInfoShowCase(tvProps, seasonProps, epProps) {
    let finalInfo = { ...tvProps };
    finalInfo.title =
      "Episode " + epProps.episode_number + ": " + epProps.title;
    finalInfo.poster_path = seasonProps.poster_path;
    finalInfo.overview = epProps.overview;
    finalInfo.release_date = epProps.release_date;
    finalInfo.country = null;
    finalInfo.runtime = epProps.runtime;
    finalInfo.credits = {};
    finalInfo.credits.cast = epProps.guest_stars;
    finalInfo.others = {};
    if (epProps.crew.length > 0) {
      epProps.crew.forEach((element) => {
        let job = element.job;
        let name = element.name;
        finalInfo.others[job] = name;
      });
    }
    return finalInfo;
  }

  //Custom BreadCrumb Tabs
  const styleBreadCrumb = {
    marginLeft: "calc(400vw/30)",
    marginRight: "calc(200vw/30)",
  };

  function customPathBreadCrumb(tvProps, seasonProps, epProps) {
    let tvName = tvProps.title;
    let seasonName = seasonProps.name;
    let epName = "Episode " + epProps.episode_number + ": " + epProps.title;

    return [
      { label: tvName, url: `/details/tv/${tvId}` },
      { label: seasonName, url: `/details/tv/${tvId}/${seasonId}` },
      {
        label: epName,
        url: `/details/tv/${tvId}/${seasonId}/${episodeId}`,
      },
    ];
  }

  return (
    <>
      <div className="detail-page">
        <Header />
        {episodeData == null ? (
          <h3>Loading...</h3>
        ) : detailDataList.detailListError ? (
          <h3>Error 404</h3>
        ) : (
          <div className="mov_details_page_content_wrapper">
            <div className="ep_page_info_wrapper">
              <div
                className="ep_page breadcrumb_wrapper"
                style={styleBreadCrumb}
              >
                <Breadcrumb
                  paths={customPathBreadCrumb(
                    detailDataList.detailList.tvList[tvId],
                    seasonData.seasonDetail.seasonInfo,
                    episodeData,
                  )}
                />
              </div>
              <InfoShowcase
                detailData={customInfoShowCase(
                  detailDataList.detailList.tvList[tvId],
                  seasonData.seasonDetail.seasonInfo,
                  episodeData,
                )}
              />

              <div
                className="ep_page image_showcase"
                style={{ marginBottom: "5vw" }}
              >
                {!episodeData.images || imageLoading ? (
                  <h2>Image Loading...</h2>
                ) : imageError ? (
                  <h2>Image Error 404</h2>
                ) : (
                  <ImageShowcase imageItems={episodeData.images.stills} />
                )}
              </div>
              <WatchShowcase
                detailData={tvDetailData}
                type="tv"
                season={seasonId}
                episode={episodeId}
              />
            </div>
            <div className="ep_page_season_showcase_wrapper">
              <SeasonShowcase
                detailData={tvDetailData.seasons}
                tvId={tvId}
                title={tvDetailData.title}
              />
            </div>
          </div>
        )}
      </div>
      <SideBar />
    </>
  );
};
